// simulator_helper.js
import axios from "axios";
import { post, del, get, put } from "./api_helper";
import * as url from "./url_helper";

// ============= MARK SIMULATOR RECORDS =============

export const markStudentSimulator = (data) => post(url.MARK_SIMULATOR, data);
export const markAllStudentSimulator = (data) => post(url.MARK_ALL_SIMULATOR, data);

// ============= GET SIMULATOR RECORDS =============

// Get all records for a batch (no date filter - one-time activity)
export const getAllStudentSimulator = (batchId) => {
    return get(`${url.GET_ALL_SIMULATOR}${batchId}`);
};

// Get statistics (no date filter)
export const getSimulatorStatistics = (batchId) => {
    return get(`${url.GET_SIMULATOR_STATISTICS}${batchId}`);
};

// ============= DELETE SIMULATOR RECORDS =============

// Delete a single simulator record by ID
export const deleteSimulatorRecord = (recordId) => {
    return del(`${url.DELETE_SIMULATOR_RECORD}${recordId}`);
};

// Delete all records for a student
export const deleteStudentSimulatorRecords = (studentId) => {
    return del(`${url.DELETE_STUDENT_SIMULATOR}${studentId}`);
};

// Delete all records for a batch
export const deleteBatchSimulatorRecords = (batchId) => {
    return del(`${url.DELETE_BATCH_SIMULATOR}${batchId}`);
};

// ============= EXPORT SIMULATOR EXCEL =============

export const downloadSimulatorExcel = (batchId) => {
    const authUser = localStorage.getItem('authUser');
    const token = authUser ? JSON.parse(authUser)?.token : '';
    
    return axios.get(`${url.SIMULATOR_EXCEL}${batchId}`, {
        responseType: 'blob',
        headers: {
            'Authorization': `Bearer ${token || ''}`,
            'X-Organization-ID': authUser ? JSON.parse(authUser)?.organizationId : ''
        }
    });
};



// import axios from "axios";
// import { post, del, get, put } from "./api_helper";
// import * as url from "./url_helper";

// // ============= MARK SIMULATOR RECORDS =============

// /**
//  * Mark a single student's simulator record
//  * @param {Object} data - Simulator data
//  * @returns {Promise} API response
//  */
// export const markStudentSimulator = (data) => post(url.MARK_SIMULATOR, data);

// /**
//  * Mark all students' simulator records (bulk operation)
//  * @param {Array} data - Array of simulator records
//  * @returns {Promise} API response
//  */
// export const markAllStudentSimulator = (data) => post(url.MARK_ALL_SIMULATOR, data);

// // ============= GET SIMULATOR RECORDS =============

// /**
//  * Get all simulator records for a batch on a specific date
//  * @param {number} batchId - Batch ID
//  * @param {string} date - Date in YYYY-MM-DD format
//  * @returns {Promise} API response
//  */
// export const getAllStudentSimulator = (batchId, date) => {
//     return get(`${url.GET_ALL_SIMULATOR}${batchId}?date=${date}`);
// };

// /**
//  * Get simulator records for a batch within date range
//  * @param {number} batchId - Batch ID
//  * @param {string} fromDate - Start date in YYYY-MM-DD format
//  * @param {string} toDate - End date in YYYY-MM-DD format
//  * @returns {Promise} API response
//  */
// export const getSimulatorByDateRange = (batchId, fromDate, toDate) => {
//     return get(`${url.GET_SIMULATOR_RANGE}${batchId}/range?fromDate=${fromDate}&toDate=${toDate}`);
// };

// /**
//  * Get simulator statistics for a batch on a specific date
//  * @param {number} batchId - Batch ID
//  * @param {string} date - Date in YYYY-MM-DD format
//  * @returns {Promise} API response
//  */
// export const getSimulatorStatistics = (batchId, date) => {
//     return get(`${url.GET_SIMULATOR_STATISTICS}${batchId}/statistics?date=${date}`);
// };

// // ============= DELETE SIMULATOR RECORDS =============

// /**
//  * Delete simulator records for a batch on a specific date
//  * @param {number} batchId - Batch ID
//  * @param {string} date - Date in YYYY-MM-DD format
//  * @returns {Promise} API response
//  */
// export const deleteSimulatorRecords = (batchId, date) => {
//     return del(`${url.DELETE_SIMULATOR_RECORDS}${batchId}?date=${date}`);
// };

// /**
//  * Delete all simulator records for a student
//  * @param {number} studentId - Student ID
//  * @returns {Promise} API response
//  */
// export const deleteStudentSimulatorRecords = (studentId) => {
//     return del(`${url.DELETE_STUDENT_SIMULATOR}${studentId}`);
// };

// /**
//  * Delete all simulator records for a batch (cleanup on batch deletion)
//  * @param {number} batchId - Batch ID
//  * @returns {Promise} API response
//  */
// export const deleteBatchSimulatorRecords = (batchId) => {
//     return del(`${url.DELETE_BATCH_SIMULATOR}${batchId}/cleanup`);
// };

// // ============= EXPORT SIMULATOR EXCEL =============

// /**
//  * Download simulator excel report using axios directly (for blob response)
//  * @param {number} batchId - Batch ID
//  * @param {string} fromDate - Start date in YYYY-MM-DD format
//  * @param {string} toDate - End date in YYYY-MM-DD format
//  * @returns {Promise} API response with blob data
//  */
// export const downloadSimulatorExcel = (batchId, fromDate, toDate) => {
//     const authUser = localStorage.getItem('authUser');
//     const token = authUser ? JSON.parse(authUser)?.token : '';
    
//     return axios.get(`${url.SIMULATOR_EXCEL}${batchId}?fromDate=${fromDate}&toDate=${toDate}`, {
//         responseType: 'blob',
//         headers: {
//             'Authorization': `Bearer ${token || ''}`,
//             'X-Organization-ID': authUser ? JSON.parse(authUser)?.organizationId : ''
//         }
//     });
// };